module.exports = __webpack_public_path__ + "media/assets_v3/images/csgo-ranks/10-d3ac03cd1f6eeba3bf18a18407168de2.png";